import { PlusOutlined } from '@ant-design/icons';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { BellScheduleForm } from 'entities/bell-schedule';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { useBellScheduleCreate } from '../model';

interface BellScheduleCreateProps {
  refreshTable: () => void;
}

export const BellScheduleCreate = ({ refreshTable }: BellScheduleCreateProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  } = useBellScheduleCreate({ refreshTable });

  return (
    <>
      <AppButton
        type="primary"
        icon={<PlusOutlined />}
        onClick={showModal}
        style={{ alignSelf: 'flex-end', width: 'fit-content' }}
      >
        Создать расписание звонков
      </AppButton>

      <AppModal
        title="Новое расписание"
        visible={modalVisible}
        onCancel={hideModal}
        content={<BellScheduleForm form={form} />}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Создать
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
